import { render } from "./finderMatches.vue?vue&type=template&id=42ab61f0&scoped=true&ts=true"
import script from "./finderMatches.vue?vue&type=script&lang=ts"
export * from "./finderMatches.vue?vue&type=script&lang=ts"

import "./finderMatches.vue?vue&type=style&index=0&id=42ab61f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ab61f0"]])

export default __exports__